module.exports = __webpack_public_path__ + "img/ic_24_social_twitter.5004ae51.svg";